export class CycleSearchModel {
    constructor() {
        this.columnFilters = [];
    }
}
export default class CycleSearch extends CycleSearchModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
